<template>
  <ul class="Files">
    <li
      v-for="(file, index) in files"
      :key="index"
      class="d-flex Files_item align-center pa-4 mb-2"
    >
      <div class="Files_icon mr-2">
        <v-img
          class="Files_icon"
          :src="'./assets/icons/file-icon.svg'"
        />
      </div>
      <span class="flex-grow-1 label">
        {{ file.name }}
      </span>
      <v-btn
        v-if="file.links && file.links.self"
        v-ripple="false"
        class="btn-wesave no-padding unset-min-width mr-2"
        text
        :href="file.links.self"
        target="_blank"
      >
        <v-icon color="#009ee0">mdi-eye</v-icon>
      </v-btn>
      <v-btn
        v-if="!isReadOnly"
        v-ripple="false"
        class="btn-wesave no-padding unset-min-width"
        text
        @click="onRemove(file)"
      >
        <img
          alt=""
          width="32"
          height="32"
          :src="'./assets/icons/close-blue.svg'"
          class="picto"
        />
      </v-btn>
    </li>
  </ul>
</template>

<script>
  export default {
    props: {
      files: {
        type: Array,
        required: true,
      },
      isReadOnly: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      onRemove(file) {
        this.$emit('removeFile', file)
      },
    },
  }
</script>

<style scoped lang="scss">
// @todo : import this file once for all
@import '~@/styles/app.scss';

$label-success: $color-001c4b;
$label-missing: $color-f07d00;
$label-invalid: $color_ea3b38;

$action-success: $color-009ee0;
$action-missing: $color-f07d00;
$action-invalid: $color_ea3b38;

$bg-success: $color-f5f6fa;
$bg-missing: $color-240_125_0_04;
$bg-invalid: $color-234_59_56_04;

.Files {
  padding: 0;

  &_item {
    background: $color-f5f6fa;

    .label {
      color: $color-001c4b;
      font-weight: $font-weight-medium;
    }

    &_icon {
      width: 2rem;
    }

    &--success {
      background: $bg-success;

      .label {
        color: $label-success;
      }
      .actionLabel {
        color: $action-success;
      }
    }

    &--missing {
      border: 1px dashed $label-missing;
      background: $bg-missing;

      .label {
        color: $label-missing;
      }
      .actionLabel {
        color: $action-missing;
      }
    }

    &--invalid {
      border: 1px dashed $label-invalid;
      background: $bg-invalid;

      .label {
        color: $label-invalid;
      }
      .actionLabel {
        color: $action-invalid;
      }
    }
  }
}
</style>
